import React from 'react';
import { ENUM_LOCALE_CODE } from 'global.enums';
import { IIcon, useIconProps } from '../useIconProps';
import SvgIconAR from './country-flag-arabian.svgrIcon.svg';
import SvgIconCN from './country-flag-china.svgrIcon.svg';
import SvgIconID from './country-flag-indonesia.svgrIcon.svg';
import SvgIconMY from './country-flag-malaysia.svgrIcon.svg';
import SvgIconNoFlag from './country-flag-no-flag.svgrIcon.svg';
import SvgIconPT from './country-flag-portuguese.svgrIcon.svg';
import SvgIconES from './country-flag-spain.svgrIcon.svg';
import SvgIconTH from './country-flag-thailand.svgrIcon.svg';
import SvgIconUK from './country-flag-uk.svgrIcon.svg';
import SvgIconVI from './country-flag-vietnam.svgrIcon.svg';

interface ICountryFlagIcon extends IIcon {
  locale: ENUM_LOCALE_CODE;
}

export const CountryFlagIcon = React.forwardRef(({ locale, ...props }: ICountryFlagIcon, ref) => {
  const iconProps = useIconProps({
    ref,
    size: 20,
    ...props,
  });

  const renderIcon = () => {
    switch (locale) {
      case ENUM_LOCALE_CODE.enUS:
        return <SvgIconUK {...iconProps} />;
      case ENUM_LOCALE_CODE.idID:
        return <SvgIconID {...iconProps} />;
      case ENUM_LOCALE_CODE.msMY:
        return <SvgIconMY {...iconProps} />;
      case ENUM_LOCALE_CODE.thTH:
        return <SvgIconTH {...iconProps} />;
      case ENUM_LOCALE_CODE.viVN:
        return <SvgIconVI {...iconProps} />;
      case ENUM_LOCALE_CODE.esES:
        return <SvgIconES {...iconProps} />;
      case ENUM_LOCALE_CODE.zhCN:
        return <SvgIconCN {...iconProps} />;
      case ENUM_LOCALE_CODE.ar:
        return <SvgIconAR {...iconProps} />;
      case ENUM_LOCALE_CODE.ptPT:
        return <SvgIconPT {...iconProps} />;
      default:
        return <SvgIconNoFlag {...iconProps} />;
    }
  };

  return renderIcon();
});
